import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './auth/AuthContext';
import App from './App';
import MaintenanceScreen from './components/MaintenanceScreen';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element missing from index.html');

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
      {/* A sibling of the app, not a replacement for it: whatever screen is
          underneath — a half-rung bill included — stays mounted. */}
      <MaintenanceScreen />
    </AuthProvider>
  </StrictMode>,
);
